import React, { useEffect } from 'react';

const PrivacyPolicy = () => {
  useEffect(() => {
    // Load the GetTerms embed script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'getterms-embed-js';
    script.src = 'https://gettermscdn.com/dist/js/embed.js';
    
    // Check if script already exists
    if (!document.getElementById('getterms-embed-js')) {
      const ref = document.getElementsByTagName('script')[0];
      if (ref) {
        ref.parentNode.insertBefore(script, ref);
      } else {
        document.head.appendChild(script);
      }
    }

    return () => {
      // Clean up script when component unmounts
      const existingScript = document.getElementById('getterms-embed-js');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  // Add global styles for getterms content
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      .getterms-document-embed,
      .getterms-document-embed * {
        color: #f8fafc !important; /* slate-100 */
      }
      .getterms-document-embed a {
        color: #fbbf24 !important; /* amber-400 */
        text-decoration: none;
      }
      .getterms-document-embed a:hover {
        text-decoration: underline;
      }
      .getterms-document-embed h1,
      .getterms-document-embed h2,
      .getterms-document-embed h3 {
        color: #f8fafc !important; /* slate-100 */
        margin-top: 1.5em;
        margin-bottom: 0.75em;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <section className="py-24 min-h-screen bg-slate-900">
      <div className="max-w-4xl mx-auto px-6">
        <div className="space-y-8">
          <h1 className="text-4xl md:text-5xl font-serif text-slate-100 mb-6">
            Privacy Policy
          </h1>
          <div className="w-16 h-px bg-amber-400 mx-auto mb-8" />
          
          <div 
            className="getterms-document-embed bg-slate-800/50 rounded-lg p-8 min-h-[600px] text-slate-100"
            data-getterms="JPOHP"
            data-getterms-document="privacy"
            data-getterms-lang="en-us"
            data-getterms-mode="direct"
            data-getterms-env="https://gettermscdn.com"
          >
            <div className="text-slate-300 text-center py-12">
              Loading Privacy Policy...
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;